import $ from 'jquery';
import ProductEvents from './product-events';

export default class HospitalitySuitsEvents {
    constructor() {
        this.hospItemClass = '.ff-hosp-suite-component';
        this.init();
    }

    init() {
        const $hospItems = $(this.hospItemClass);
        if ($hospItems.length) {
            const productEvent = new ProductEvents(null, null, 'hospitality_suits');
            productEvent.promoImpressionEvent($hospItems.toArray());
        }
    }
}
